var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"loading":_vm.loading,"title":"Plantonistas","large":"","hide-footer":""}},[_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }